import React from 'react';

const ContactForm = () => {
  const usStates = [
    { value: "Alabama", label: "Alabama" },
    { value: "Alaska", label: "Alaska" },
    { value: "Arizona", label: "Arizona" },
    { value: "Arkansas", label: "Arkansas" },
    { value: "California", label: "California" },
    { value: "Colorado", label: "Colorado" },
    { value: "Connecticut", label: "Connecticut" },
    { value: "Delaware", label: "Delaware" },
    { value: "Florida", label: "Florida" },
    { value: "Georgia", label: "Georgia" },
    { value: "Hawaii", label: "Hawaii" },
    { value: "Idaho", label: "Idaho" },
    { value: "Illinois", label: "Illinois" },
    { value: "Indiana", label: "Indiana" },
    { value: "Iowa", label: "Iowa" },
    { value: "Kansas", label: "Kansas" },
    { value: "Kentucky", label: "Kentucky" },
    { value: "Louisiana", label: "Louisiana" },
    { value: "Maine", label: "Maine" },
    { value: "Maryland", label: "Maryland" },
    { value: "Massachusetts", label: "Massachusetts" },
    { value: "Michigan", label: "Michigan" },
    { value: "Minnesota", label: "Minnesota" },
    { value: "Mississippi", label: "Mississippi" },
    { value: "Missouri", label: "Missouri" },
    { value: "Montana", label: "Montana" },
    { value: "Nebraska", label: "Nebraska" },
    { value: "Nevada", label: "Nevada" },
    { value: "New Hampshire", label: "New Hampshire" },
    { value: "New Jersey", label: "New Jersey" },
    { value: "New Mexico", label: "New Mexico" },
    { value: "New York", label: "New York" },
    { value: "North Carolina", label: "North Carolina" },
    { value: "North Dakota", label: "North Dakota" },
    { value: "Ohio", label: "Ohio" },
    { value: "Oklahoma", label: "Oklahoma" },
    { value: "Oregon", label: "Oregon" },
    { value: "Pennsylvania", label: "Pennsylvania" },
    { value: "Rhode Island", label: "Rhode Island" },
    { value: "South Carolina", label: "South Carolina" },
    { value: "South Dakota", label: "South Dakota" },
    { value: "Tennessee", label: "Tennessee" },
    { value: "Texas", label: "Texas" },
    { value: "Utah", label: "Utah" },
    { value: "Vermont", label: "Vermont" },
    { value: "Virginia", label: "Virginia" },
    { value: "Washington", label: "Washington" },
    { value: "West Virginia", label: "West Virginia" },
    { value: "Wisconsin", label: "Wisconsin" },
    { value: "Wyoming", label: "Wyoming" },
    { value: "District of Columbia", label: "District of Columbia" },
    { value: "American Samoa", label: "American Samoa" },
    { value: "Guam", label: "Guam" },
    { value: "Northern Mariana Islands", label: "Northern Mariana Islands" },
    { value: "Puerto Rico", label: "Puerto Rico" },
    { value: "U.S. Virgin Islands", label: "U.S. Virgin Islands" },
  ];

  return (
    <div className="w-full flex justify-center px-4 sm:px-6 lg:px-8 mt-10 lg:mt-0">
      <div className="bg-[#F9F7F7] rounded-2xl shadow-lg p-6 sm:p-8 lg:p-10 w-full max-w-lg text-[#112D4E]">
        <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-center lg:text-left">
          Start a Free Case Review
        </h2>
        <form className="space-y-4">
          {/* Name Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">First Name*</label>
              <input
                type="text"
                
                className="w-full p-3 rounded-lg bg-[#E6E9F0] border border-[#DBE2EF] text-[#000] focus:outline-none focus:ring-2 focus:ring-[#3F72AF]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Last Name*</label>
              <input
                type="text"
                className="w-full p-3 rounded-lg bg-[#E6E9F0] border border-[#DBE2EF] text-[#000] focus:outline-none focus:ring-2 focus:ring-[#3F72AF]"
              />
            </div>
          </div>

          {/* Contact Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Phone Number*</label>
              <input
                type="tel"
                className="w-full p-3 rounded-lg bg-[#E6E9F0] border border-[#DBE2EF] text-[#000] focus:outline-none focus:ring-2 focus:ring-[#3F72AF]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Email*</label>
              <input
                type="email"
                className="w-full p-3 rounded-lg bg-[#E6E9F0] border border-[#DBE2EF] text-[#000] focus:outline-none focus:ring-2 focus:ring-[#3F72AF]"
              />
            </div>
          </div>

          {/* Child's Birth Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Child's Birth State*</label>
              <select className="w-full p-3 rounded-lg bg-[#E6E9F0] border border-[#DBE2EF] text-[#000] focus:outline-none focus:ring-2 focus:ring-[#3F72AF]">
                <option value="">- Select State -</option>
                {usStates.map((state) => (
                  <option key={state.value} value={state.value}>
                    {state.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Child's Birthday*</label>
              <input
                type="date"
                className="w-full p-3 rounded-lg bg-[#E6E9F0] border border-[#DBE2EF] text-[#000] focus:outline-none focus:ring-2 focus:ring-[#3F72AF]"
              />
            </div>
          </div>

          {/* Story */}
          <div>
            <label className="block text-sm font-medium mb-1">Tell us your story (optional)</label>
            <textarea
              className="w-full p-3 rounded-lg bg-[#E6E9F0] border border-[#DBE2EF] text-[#000] focus:outline-none focus:ring-2 focus:ring-[#3F72AF]"
              rows="4"
            />
          </div>

          {/* Consent */}
          <p className="text-xs text-[#6B7C9D] leading-snug">
            By submitting this form, I consent to be contacted by Sokolove Law
            and its co-counsel regarding my potential claim. Consent is not
            required to use their services. Msg frequency varies. Msg & data
            rates may apply. Read our{' '}
            <a href="#" className="text-[#000] underline">Terms</a> and{' '}
            <a href="#" className="text-[#000] underline">Privacy Policy</a>.
          </p>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#DBE2EF] text-[#112D4E] py-3 rounded-lg font-semibold hover:bg-[#344B47] hover:text-[#F9F7F7] transition"
          >
            Start My Free Case Review
          </button>

          <div className="flex items-center justify-center text-xs text-[#000] mt-2">
            <span className="mr-1">🔒</span> SECURE SUBMISSION
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
